import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PayEphemeralKey } from '../../models/PayEphemeralKey'

export const PayEphemeralKeyMock = Factory.Sync.makeFactory<PayEphemeralKey>({
  secret: Factory.each(() => `ek_${faker.random.alphaNumeric(36)}`),
  expires: Math.ceil(Date.now() / 1000) + 3600,
})
